import React from "react";
import { PageHero, CTABlock, SectionLabel, CheckList } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";

const points = [
  "Flexibel städning efter öppettider",
  "Noggranna städinstruktioner per butik",
  "Kompetent och kontrollerad personal",
  "Ansvarsförsäkring upp till 10 miljoner",
];

export default function Butiksstadning() {
  return (
    <>
      <PageHero
        eyebrow="Företagstjänst"
        title="Butiksstädning som gör skillnad"
        intro="En ren och fräsch butik gör stor skillnad för både kunder och personal. Rena Tjänster hjälper butiker med regelbunden städning anpassad efter öppettider, ytor och rutiner."
        image={ASSETS.shopCleaning}
        imageAlt="Butiksstädning av Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="butik-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <section className="py-20 lg:py-28" data-testid="butik-content">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <SectionLabel className="mb-4">Tydliga rutiner</SectionLabel>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-4">
              Anpassat efter er butik
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Vi tar tillsammans fram tydliga städinstruktioner för just er butik och anpassar arbetet
              efter era önskemål – så att resultatet blir konsekvent dag efter dag.
            </p>
          </div>
          <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 lg:p-10">
            <h3 className="font-display text-xl font-semibold mb-5">Det här lyfter vi</h3>
            <CheckList items={points} />
          </div>
        </div>
      </section>

      <CTABlock
        title="Vill ni ha hjälp med butiksstädning?"
        description="Vi tar fram tydliga instruktioner och anpassar arbetet efter era öppettider och rutiner."
      />
    </>
  );
}
